<template>
<BaseFaq/>
</template>
<script>
import BaseFaq from '@/components/BaseFaq.vue'
export default {
  components: {
    BaseFaq
  }
}
</script>

